import { User } from 'lib-shared-types-api';

export type UserMergeValidity = {
  valid: boolean;
  reason: string;
};

/**
 * Function that returns a an object with the property valid if a user can be
 * merged and a reason if it cannot
 *
 * @param user - The user object to validate
 * @returns UserMergeValidity
 */
export function validateIfUserCanMerge(user: User): UserMergeValidity {
  if (user.type !== 'contact') {
    return {
      valid: false,
      reason: 'Only End Users can be merged',
    };
  }

  return {
    valid: true,
    reason: '',
  };
}
